export default __webpack_public_path__ + "static/media/esperenza2.64b2f546.jpg";